<template>
<v-container class="text-center px-5">
  <v-row>
    <v-col>
      <v-btn-toggle v-model="type" mandatory>
        <v-btn small value="exact">Exact</v-btn>
        <v-btn small value="since">Since</v-btn>
        <v-btn small value="until">Until</v-btn>
        <v-btn small value="between">Between</v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>
  <v-row class="mt-5">
    <v-col v-if="type == 'exact'">
      <year-field v-model="exact" label="Year" />
    </v-col>
    <v-col v-if="type == 'since' || type == 'between'">
      <year-field v-model="since" label="Since" />
    </v-col>
    <v-col v-if="type == 'until' || type == 'between'">
      <year-field v-model="until" label="Until" />
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import YearField from "@/components/search/fields/YearField"

export default {
  name: "YearFilterBuilder",
  components: {
    YearField,
  },
  data() {
    return {
      type: "exact",
      exact: new Date().getFullYear(),
      since: 1890,
      until: new Date().getFullYear(),
    }
  },
  methods: {
    init() {
      this.type = "exact"
      this.exact = new Date().getFullYear()
      this.since = 1980
      this.until = new Date().getFullYear()
    },
    build(negate) {
      const prefix = negate ? "not " : ""
      const op = negate ? "or" : "and"
      switch (this.type) {
        case "exact":
          return [`${prefix}made in ${this.exact}`]
        case "since":
          return [`${prefix}made after ${this.since}`]
        case "until":
          return [`${prefix}made before ${this.until}`]
        case "between":
          if (this.since > this.until)
            return [null, "Start of range should be before end of range"]
          return [`${prefix}made after ${this.since} ` +
                  `${op} ${prefix}made before ${this.until}`]
      }
      return ""
    },
  }
}
</script>
